import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const Facebook: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    aria-hidden={!title}
    focusable='false'
    width={width}
    height={height}
    {...props}
  >
    <path
      d='M19.0115 6.50781H14.4998V9.5H17.4998V14.5H14.4998V23.5H8.49194V14.5H5.49194V9.5H8.48706L8.48901 9.00195L8.49878 6.74023C8.50413 5.51021 8.50608 4.93064 8.52319 4.58496C8.53871 4.27198 8.56434 4.18254 8.63062 3.91406C9.07392 2.11854 10.6046 0.760301 12.4451 0.532227C12.507 0.524556 12.7284 0.516059 13.3083 0.510742C13.8711 0.505586 14.7426 0.503938 16.074 0.50293L19.0115 0.5V6.50781ZM16.4958 10.5059L14.5037 10.498L13.5076 10.4932V5.49219H17.9958V1.49121L17.4949 1.49219L15.2449 1.49512C14.0252 1.49701 12.8814 1.50676 12.7292 1.51855C11.8981 1.58377 11.1271 1.93763 10.5408 2.52539C10.0654 3.00197 9.78275 3.50521 9.60229 4.17871L9.53784 4.41895L9.52124 4.48145V4.54688L9.51343 7.76855L9.50757 10.4922H6.50757V13.5078H9.50757V22.5107L10.0095 22.5088L11.5037 22.502L12.9978 22.4961L13.4949 22.4941L13.4958 21.9971L13.5017 17.5029L13.5076 13.5059L16.4958 13.4941V10.5059Z'
      fill={fill}
      stroke={fill}
    />
  </svg>
)

export default Facebook
